export const NOTE_AUTOSAVE_INTERVAL_MS = 1000
export const SHOW_NOTE_SAVED_INTERVAL = 2000
